import { SetStateAction } from "react";
import { MRT_RowSelectionState } from "material-react-table";
import * as _ from "lodash";

export const handleInitialItemSelect = (
  isArchive: boolean,
  isBookingCancelled: boolean,
  initialData: Array<{ id: number } & Record<string, any>>,
  setRowSelection: (value: SetStateAction<MRT_RowSelectionState>) => void
) => {
  if (isArchive || isBookingCancelled) return setRowSelection({});

  const orderedItems = _.uniqBy(initialData, item => item.id).map(i => i.id);
  if (!orderedItems.length) return;

  for (const item of orderedItems) {
    setRowSelection(prev => ({ ...prev, [`${item}`]: true }));
  }
};
